// angular
// 	.module("HeroPRO")
// 	.controller("FinancingTermsModalController", financingTermsModalController);

import _ from 'lodash';
import './financingTermsModal.scss';


/* @ngInject */
export default function financingTermsModalController($uibModalInstance, FinancingFactory, $state, $stateParams, DirectiveService, FinancingConfig) {
    const vm = this;

    vm.currentView = 'viewAvailableRates'; // viewAvailableRates || confirmSelectedRates || selectedRatesConfirmed
    vm.states = {};
    vm.selectedRates = {};
    vm.allPlanRates = {};
    vm.scheduledDate = undefined;
    vm.scheduledDatePlaceholder = 'Date';
    vm.datepickerOpen = false;
    vm.selectionError = false;
    vm.phoneNumber = undefined;
    vm.scheduledRates = undefined;
    vm.effectiveDate = null;
    vm.confirmInProgress = false;
    vm.premierTier = {};

    /*= =======================================
    =            Public Functions            =
	======================================== */
    vm.datepickerMinDate = function () {
        const today = new Date(FinancingFactory.getCurrentDate());
        let firstAvailable;
        if (!_.isEmpty(vm.selectedRates)) {
            firstAvailable = new Date(vm.selectedRates[vm.selectedState.StateGeoId].FirstAvailableScheduleDate);

            // if the effective date is within two days
            // then default to normal availability of today + 2 days
            const tempDate = new Date();
            if (firstAvailable > tempDate.setDate(tempDate.getDate() + 2)) {
                return firstAvailable;
            }
        }

        firstAvailable = new Date(today.setDate(today.getDate() + 2));
        return firstAvailable;
    };

    vm.datepickerMaxDate = function () {
        const today = new Date(FinancingFactory.getCurrentDate());
        today.setMonth(today.getMonth() + 3);
        return today;
    };

    vm.datepickerOptions = {
        formatDay: 'dd',
        formatMonth: 'MM',
        formatYear: 'yyyy',
        showWeeks: false,
        startingDay: 0,
        minDate: vm.datepickerMinDate(),
        maxDate: vm.datepickerMaxDate(),
    };

    vm.switchState = function (state) {
        vm.selectedState = state;
        getAllPlanRates(vm.selectedState.StateGeoId);
    };

    vm.closeModal = function () {
        FinancingFactory.resetSelectedRates();
        $uibModalInstance.close();

        if (vm.currentView === 'selectedRatesConfirmed') {
            $state.go($state.current, $stateParams, { reload: true, inherit: false });
        }
    };

    vm.setCurrentView = function (viewName) {
        vm.currentView = viewName;
    };

    vm.toggleDatepicker = function () {
        vm.datepickerOpen = !vm.datepickerOpen;
    };
    /* -----  End of Public Functions  ------*/

    vm.getState = function (stateGeoId) {
        return _.find(vm.states, state => state.StateGeoId === Number(stateGeoId));
    };

    vm.proceedClicked = function () {
        vm.selectionError = _.isEmpty(FinancingFactory.getSelectedRates());

        if (vm.selectionError === false) {
            vm.selectedRates = FinancingFactory.getSelectedRates();
            vm.datepickerOptions = {
                formatDay: 'dd',
                formatMonth: 'MM',
                formatYear: 'yyyy',
                showWeeks: false,
                startingDay: 0,
                minDate: vm.datepickerMinDate(),
                maxDate: vm.datepickerMaxDate(),
            };
            vm.setCurrentView('confirmSelectedRates');
            DirectiveService.publish('scroll');
        }
    };

    vm.confirmClicked = function () {
        if (vm.confirmTermsForm.$valid === true && vm.cb1 && vm.cb2 && vm.cb3 && vm.confirmInProgress === false) {
            vm.confirmInProgress = true;
            FinancingFactory.confirmRates(vm.confirmTermsForm.txtTermsDatepicker.$viewValue).then((response) => {
                vm.confirmInProgress = false;
                vm.effectiveDate = response.EffectiveDate;
                vm.setCurrentView('selectedRatesConfirmed');
            });
        }
    };

    vm.doneClicked = function () {
        vm.closeModal();
    };

    vm.toggleCheckbox = function (cb) {
        cb = cb ? undefined : true;
    };

    vm.selectedStateHasNewRates = function () {
        return _.find(vm.newRatesConfig.stateGeoIds, stateGeoId => stateGeoId === vm.selectedState.StateGeoId);
    };
    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
    function init() {
        vm.newRatesConfig = FinancingConfig.newRates;
        vm.phoneNumber = FinancingFactory.getPhoneNumber();
        vm.selectedState = FinancingFactory.getSelectedState();
        getAllPlanRates(vm.selectedState.StateGeoId);
        vm.scheduledRates = FinancingFactory.getScheduledRates();

        FinancingFactory.getPremierTier().then((response => {
            vm.premierTier = response;
        }))
    }

    function getAllPlanRates(stateGeoId) {
        FinancingFactory.getAllPlanRates(stateGeoId).then(() => {
            vm.allPlanRates = FinancingFactory.getAllRates(stateGeoId);
        });
    }
    /* -----  End of Private Functions  ------*/

    init();
}



// WEBPACK FOOTER //
// ./src/app/accounts/financing/financingTermsModal/financingTermsModalController.js